import React from 'react'
import logo from '../../assets/images/avatars/logo3.png'
import { CAvatar } from '@coreui/react'
const Loader = () => {

  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role

    return (
        <div className='loader-container' style={{background:  '#0E0E0E' }}>
           
                                           <div className="d-flex align-items-center justify-content-center gap-0 ">
                                               <div className="" >
                                                   <CAvatar
                                                       src={logo}
                                                       className="rounded-0"
                                                     style={{ width: '120px', height: '120px' }}
                                                   />
                                               </div>
                                               <span
                                                   style={{
                                                       color: '#4FC3F7',
                                                       fontSize: '18px',
                                                       padding: '0 0',
                                                       marginLeft: '-10px'
                                                   }}
                                               >
                                                   Cerebrum HC
                                               </span>
                                           </div>
            <div id="container-ball">
            <div id="ball-1" class="circle-ball"></div>
            <div id="ball-2" class="circle-ball"></div>
            <div id="ball-3" class="circle-ball"></div>
            <div id="ball-4" class="circle-ball"></div>
            <div id="ball-5" class="circle-ball"></div>
        </div>
        </div>
    )
}

export default Loader
